import React from 'react';

const JobBoard = () => (
    <div className="p-12">
        <h1 className="text-4xl font-bold">Job Board</h1>
        <p className="mt-4 text-neutral-400">Content for the Job Board page goes here.</p>
    </div>
);

export default JobBoard;
